
























































import { Component, Inject, Mixins, Prop } from "vue-property-decorator";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IContract, IContractProduct } from "@/models/contracts";
import { ICProdProvider } from "@/models/providers/contractProduct";

type IRestoreStatusForm = {
  hook_context: {
    disable_provisioning_triggers?: boolean;
  };
};

@Component
export default class CProdRestoreStatusModal extends Mixins(HasValidation) {
  // Inject

  @Inject({ from: "contractProductProvider", default: () => () => ({}) })
  public readonly $cProdProvider!: () => ICProdProvider;

  // Props

  @Prop({ required: true })
  public contractId!: IContract["id"];

  @Prop({ required: true })
  public contractProductId!: IContractProduct["id"];

  // Data

  public form = {} as IRestoreStatusForm;
  public isProcessing = false;

  // Computed

  public get formIsDisabled() {
    return this.isProcessing || this.hasErrors;
  }

  // Lifecycle methods

  public async created() {
    this.form = this.initForm();
  }

  // Methods

  public initForm(): IRestoreStatusForm {
    return {
      hook_context: {
        disable_provisioning_triggers: false
      }
    };
  }

  public async validateBeforeSubmit() {
    if (this.formIsDisabled) return;
    try {
      this.isProcessing = true;
      if (!(await this.validate()))
        throw this.$t("_sentence.form_is_not_valid");

      await this.restoreManualStatus();
      this.$emit("success");
      this.$emit("close");
      this.$buefy.toast.open({
        message: this.$t("_.status_changed") as string
      });
    } catch (error) {
      this.isProcessing = false;
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
  }

  public async restoreManualStatus() {
    return this.$store.dispatch(
      `data/${DataModules.CONTRACTS_PRODUCTS}/unsetManualStatus`,
      {
        contractId: this.contractId,
        contractProductId: this.contractProductId,
        data: this.form
      }
    );
  }
}
